module.exports = __webpack_public_path__ + "static/media/300-300.1e6e40be.webp";